import PropTypes from "prop-types";
import { Card, CardBody, Col, Row } from "reactstrap";
import UserProfileAvatarWithFallback from "./UserProfileAvatarWithFallback";

const DEFAULT_USER_AVATAR =
  "https://prod.leconseillerdubtp.com/medias/default/user.png";

function safeText(value, fallback = "-") {
  if (value === null || value === undefined) return fallback;
  const text = String(value).trim();
  return text.length ? text : fallback;
}

const ProfileHeaderCard = ({
  t,
  picture,
  name,
  subtitle,
  phone,
  badge,
  actionNode,
  extraMetaNode,
}) => (
  <Card className="mb-4">
    <CardBody>
      <Row className="g-3 align-items-center">
        <Col xs="auto">
          <UserProfileAvatarWithFallback
            picture={picture}
            name={name}
            defaultUrl={DEFAULT_USER_AVATAR}
            t={t}
            imageClassName=""
            imageStyle={{
              borderRadius: "50%",
              height: "88px",
              width: "88px",
              objectFit: "cover",
              objectPosition: "center center",
            }}
            fallbackWrapperClassName="d-flex"
            fallbackTextClassName="avatar-title bg-soft-success text-success rounded-circle d-flex align-items-center justify-content-center"
            fallbackWrapperStyle={{ width: "88px", height: "88px" }}
            fallbackTextStyle={{
              width: "88px",
              height: "88px",
              fontSize: "28px",
              fontWeight: 600,
            }}
          />
        </Col>
        <Col>
          <h4 className="mb-1" style={{ textTransform: "uppercase" }}>
            {safeText(name)}
          </h4>
          {subtitle ? <p className="text-muted mb-2">{subtitle}</p> : null}
          <div className="d-flex flex-wrap align-items-center gap-2">
            {phone ? (
              <span className="text-muted">
                <i className="ri-phone-line me-1 align-middle"></i>
                {phone}
              </span>
            ) : null}
            {badge ? (
              <span className="badge badge-soft-warning text-uppercase">
                {badge}
              </span>
            ) : null}
            {extraMetaNode}
          </div>
        </Col>
        {actionNode ? (
          <Col xs={12} lg="auto" className="text-lg-end">
            {actionNode}
          </Col>
        ) : null}
      </Row>
    </CardBody>
  </Card>
);

ProfileHeaderCard.propTypes = {
  t: PropTypes.func,
  picture: PropTypes.string,
  name: PropTypes.string,
  subtitle: PropTypes.string,
  phone: PropTypes.string,
  badge: PropTypes.string,
  actionNode: PropTypes.node,
  extraMetaNode: PropTypes.node,
};

ProfileHeaderCard.defaultProps = {
  t: null,
  picture: "",
  name: "",
  subtitle: "",
  phone: "",
  badge: "",
  actionNode: null,
  extraMetaNode: null,
};

export default ProfileHeaderCard;
